import { Controller } from "@hotwired/stimulus"
import FamilyTree2 from "../familytree2"

// Connects to data-controller="family-tree"
export default class extends Controller {
  static targets = ["tree", "dialog"]
  static values = {
    people: Array,
    focus: Number
  }

  connect() {
    console.log('FOCUS IS', this.focusValue);

    const color1 = getComputedStyle(document.documentElement).getPropertyValue('--color1');
    const color2 = getComputedStyle(document.documentElement).getPropertyValue('--color2');
    const color3 = getComputedStyle(document.documentElement).getPropertyValue('--color3');
    const color4 = getComputedStyle(document.documentElement).getPropertyValue('--color4');

    let FHFTemplate = FamilyTree2.createTemplate('FHFTemplate');

    FHFTemplate.link.stroke = color2;
    FHFTemplate.link.strokeWidth = 5;
    FHFTemplate.width = 200;
    FHFTemplate.height = 155;
    FHFTemplate.nodes.focus.width = 300;
    FHFTemplate.nodes.focus.height = 232;

    FHFTemplate.html = function(node){ return `` };

    // Define basic node shape
    FHFTemplate.svg = function (node) {
        const width = node.width;
        const height = node.height;

        // Loading animation
        let loading = `
            <g transform="translate(${node.width / 2 - 24} ${node.height / 2 - 24})">
                <circle fill="#fff" cx="36" cy="24" r="0" >
                    <animate attributeName="r" begin=".67" calcMode="spline" dur="1.5s" keySplines="0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8" repeatCount="indefinite" values="0;8;0;0"/>
                </circle>
                <circle fill="#fff" cx="24" cy="24" r="0" >
                    <animate attributeName="r" begin=".33" calcMode="spline" dur="1.5s" keySplines="0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8" repeatCount="indefinite" values="0;8;0;0"/>
                </circle>
                <circle fill="#fff" cx="12" cy="24" r="0" >
                    <animate attributeName="r" begin="0" calcMode="spline" dur="1.5s" keySplines="0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8" repeatCount="indefinite" values="0;8;0;0"/>
                </circle>
            </g>
        `;

        // Default node shape
        let result = `
            <rect x="0" y="0" width="${width}" height="${height}" fill="${color4}" stroke="${color4}" stroke-width="5" />
        `;

        // Add loading animation if the node is loading
        if (node.familyMember && node.familyMember.loading) {
            result += `${loading}`;
        }

        return result;
    };

    // Add extra parts to the nodes
    FHFTemplate.insertSvg = function (node) {
        if (!(node.familyMember.loading)) {
            if (node.familyMember.obfuscated) {
                return `
                    <foreignObject x="10" y="0" width="${node.width - 20}" height="${node.height}">
                        <div xmlns="http://www.w3.org/1999/xhtml" 
                            style="width:100%; height:100%; color:white; display:flex; flex-direction: column; gap: 0.5rem; align-items:center; justify-content:center; text-align:center; font-size:16px; line-height:1.2;">
                            <div>[ OBFUSCATED ]</div>
                        </div>
                    </foreignObject>
                `;
            } else {
                let lifetime = ``;
                if (node.familyMember.lifetime) {
                    lifetime = `<div>${node.familyMember.lifetime}</div>`;
                }

                if (node.familyMember.photo) {
                    return `
                        <clipPath id="photo-clip">
                            <rect stroke-width="0" stroke="#fff" x="${node.width / 2}" y="15" rx="50" ry="50" width="70" height="70"></rect>
                        </clipPath>
                        <image preserveAspectRatio="xMidYMid slice" 

                            xlink:href="${node.familyMember.photo}" 
                            x="${node.width / 2 - 25}" y="10" width="50" height="50">
                        </image>

                        <foreignObject x="10" y="60" width="${node.width - 20}" height="${node.height - 60}">
                            <div xmlns="http://www.w3.org/1999/xhtml" 
                                style="width:100%; height:100%; color:white; display:flex; flex-direction: column; gap: 0.5rem; align-items:center; justify-content:center; text-align:center; font-size:16px; line-height:1.2;">
                                <div>${node.familyMember.name}</div>
                                ${lifetime}
                            </div>
                        </foreignObject>
                    `;
                } else {
                    return `
                        <foreignObject x="10" y="0" width="${node.width - 20}" height="${node.height}">
                            <div xmlns="http://www.w3.org/1999/xhtml" 
                                style="width:100%; height:100%; color:white; display:flex; flex-direction: column; gap: 0.5rem; align-items:center; justify-content:center; text-align:center; font-size:16px; line-height:1.2;">
                                <div>${node.familyMember.name}</div>
                                ${lifetime}
                            </div>
                        </foreignObject>
                    `;
                }
            }
        }
    }

    // FHFTemplate.insertSvg = function (node) {
    //     if (node.familyMember.lifetime) {
    //         return `
    //             <text fill="white" text-anchor="middle"
    //                 x="${node.width / 2}" y="${node.height / 2 + 45}">
    //                 ${node.familyMember.lifetime}
    //             </text>
    //         `;
    //     }
    // }



    let tree = this.treeTarget;
    let people = this.peopleValue;
    let focus = this.focusValue;
    // var data = JSON.parse(people);


    let familyTree = new FamilyTree2(tree);

    familyTree.readOnly = true;
    familyTree.templateName = 'FHFTemplate';
    let globalDistance = 80;
    let separations = familyTree.template.separations;

    separations.focusSide = globalDistance;
    separations.parentLevel = globalDistance;
    separations.parentSide = globalDistance;
    separations.parentNeighbor = globalDistance;
    separations.childInLowNeighbor = globalDistance;
    separations.focusBottom = globalDistance;
    separations.childSide = globalDistance;
    separations.childLevel = globalDistance;
    separations.childNeighbor = globalDistance;
    separations.parentSiblingNeighbor = globalDistance;
    separations.parentSiblingLevel = globalDistance;
    separations.parentInLawLevel = globalDistance;
    separations.parentInLawNeighbor = globalDistance;
    separations.piblingNeighbor = globalDistance;
    separations.siblingNeighbor = globalDistance;
    separations.spouseNeighbor = globalDistance;
    separations.stepParentNeighbor = globalDistance;

    familyTree.addFamilyMembers(people).draw(focus);

    familyTree.onDemand(function (args) {
        for (var id of args.ids) {                    
            this.addFamilyMembers([{ id: id, loading: true }]);
        }
        this.draw(this.focusId, null, function(){
            // this.fit();
            fetch(`/fetch_people/${args.ids.join(',')}`)
                .then((data) => data.json())
                .then((data) => familyTree.addFamilyMembers(data).draw())
        });

        // fetch(`/fetch_people/${args.ids.join(',')}`)
        //     .then((data) => data.json())
        //     .then((data) => familyTree.addFamilyMembers(data).draw())
    });
    
    familyTree.onNodeClick(function(args) {
        let id = parseInt(args.node.id);
        let node_detail_dialog = document.querySelector('#node_detail_dialog');

        fetch("/fetch_node_detail/" + id)
        .then(function (response) {
            return response.text();
        })
        .then(function (data) {
            var parser = new DOMParser();
            var html = parser.parseFromString(data, "text/html");

            node_detail_dialog.innerHTML = new XMLSerializer().serializeToString(html);
            node_detail_dialog.showModal();

            // document.querySelectorAll('.person-chip').forEach((person_chip) => {
            //     person_chip.addEventListener("click", function (e) {
            //         node_detail_dialog.close();
            //         familyTree.centerNodes([parseInt(args.familyMemberId)]);                    
            //     });
            // })

            // Focuses on the node when clicked
            document.querySelector('.focus-button').addEventListener("click", function (e) {
                id = this.dataset.id;
                node_detail_dialog.close();
                familyTree.draw(id);
            });
        })
        .catch(function (err) {
            console.warn("Something went wrong.", err);
        });
    });

    familyTree.onNodeClick(function(args){    
        if (this.readOnly){
            familyTree.center(args.node);
            // this.centerNodes([args.node]);
        }
    });

    console.log(people);
  }
}
